import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return (
    <div className="min-h-screen bg-[#09090B] text-white flex flex-col">
      <Header />
      <main className="flex-1 pt-[92px]" data-testid="page-main">{children}</main>
      <Footer />
    </div>
  );
};
